module.exports = __webpack_public_path__ + "media/images/amplifi-4224e087801201595c7b8e04ec253bbd.png";